<template>
	<div class="simple-text" :key="getValue" :class="getClasses" v-mask="getMask">
		{{ getValue }}
	</div>
</template>

<script setup>
import { computed } from 'vue'
/** Props received:
@value {String, Number} - value to be displayed, when a simple string or number
or
@value {Object} when we need classes or masks, object with:
	content {String, Number} value displayed
	classes {String} classes that will be added to component
	mask {Object} mask to format text
*/
const props = defineProps({
	value: [String, Number, Object]
})

const getClasses = computed(() => {
    return props.value ? props.value.classes || null : null
})

const getValue = computed(() => {
    return props.value ? props.value.content || props.value : null
})

const getMask = computed(() => {
    return props.value ? props.value.mask || null : null
})
</script>

<style lang="scss" scoped>
.simple-text {
	width: auto;

	@include H7-Regular;
	color: var(--secondary-dark-2);
	text-align: inherit;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	&.capitalize {
		text-transform: capitalize;
	}
}
</style>
